import React, { ReactElement } from "react";
import { blue } from "../../theme";
//import BadgeIcon from "@icons/statisticsBadgeIcon.svg";
import styles from "./statistics.module.scss";
import { Text } from "@kunduz/ui-atoms";

export const Statistics = (props: Props): ReactElement => {
  const BadgeIcon = props.badgeIcon;
  return (
    <section className={styles.base}>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.headingAndSupportingText}>
            <div className={styles.badge}>
              <BadgeIcon />
              <Text variant="textmd" weight="bold" className={styles.badgeText}>
                {props.badgeText}
              </Text>
            </div>
            <p className={styles.heading}>{props.title}</p>
            <p className={styles.supportingText}>{props.supportingText}</p>
          </div>
          <div className={styles.content2}>
            {props.points?.map((p, i) => (
              <div key={i} className={styles.metricItem}>
                <Text variant="displaysm" weight="bold" color={blue[600]}>
                  {p.value}%
                </Text>
                <Text
                  variant="textsm"
                  color={blue[900]}
                  style={{ textAlign: "center" }}
                >
                  {p.label}
                </Text>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

interface Props {
  badgeText: string;
  badgeIcon: React.ElementType;
  title: string;
  supportingText: string;
  points: {
    value: number;
    label: string;
  }[];
}
